export const PaperDropdownStyle = {
  style: {
    marginLeft: '0px',
    marginTop: '8px',
    boxShadow:
      'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.15) 0px 0px 0px 1px',
  },
}
